import { ConfirmationPopupModel } from './confirmation-popup/confirmation-popup.model';

export enum PopupType {
    Confirmation = 'CONFIRMATION',
}

export interface PopupBase {
    id: string;
    type: PopupType;
}

export type Popup = ConfirmationPopupModel;
